const o = window;
o.AS || (o.AS = {}), o.o_global || (o.o_global = {}), o.o_util || (o.o_util = {});
o.__toggles__ || (o.__toggles__ = {});
const { o_global: g, o_util: s } = o;
export {
  g,
  o,
  s
};
/*                                                   */
